import React, { useState } from "react";
import Button from "components/button";
import chev from "assets/icons/chevron.svg";
import search from "assets/icons/search.svg";
import filter from "assets/icons/filter.svg";
import sort from "assets/icons/sort.svg";
import InvoiceTable from "components/table/invoice-table";
import { useNavigate } from "react-router-dom";

export default function MobileInvoiceHistory() {
  const [isExportDropdownOpen, setIsExportDropdownOpen] = useState(false);

  const navigate = useNavigate();
  const handleOnclick = () => {
    navigate("/invoice-history/view-invoice");
  };

  const exportOptions = [
    {
      label: "Print",
      icon: "📄",
      onClick: () => {
        handleOnclick();
        setIsExportDropdownOpen(false);
      },
    },
    {
      label: "Excel",
      icon: "📊",
      onClick: () => {
        console.log("Exporting as Excel");
        setIsExportDropdownOpen(false);
      },
    },
    {
      label: "CSV",
      icon: "📁",
      onClick: () => {
        console.log("Exporting as CSV");
        setIsExportDropdownOpen(false);
      },
    },
    {
      label: "PDF",
      icon: "📄",
      onClick: () => {
        console.log("Exporting as PDF");
        setIsExportDropdownOpen(false);
      },
    },
  ];

  return (
    <div className="h-full w-full flex flex-col gap-3  items-center justify-start ">
      <div className=" w-full flex justify-between items-start">
        <h1 className="text-[26px] font-bold">Invoice History</h1>
      </div>
      <div className="h-fit w-full flex flex-col  items-center justify-start gap-4">
        <div className="w-full flex items-center justify-end">
          <div className="flex items-center gap-5">
            <div className="flex gap-3 justify-end ">
              <button className="btn flex">
                <img src={search} alt="" />
                Search
              </button>
              <button className="btn flex">
                <img src={filter} alt="" />
                Filter
              </button>
              <button className="btn flex">
                <img src={sort} alt="" />
                Sort
              </button>
            </div>
            <div className="relative">
              <Button
                label="Export"
                onClick={() => setIsExportDropdownOpen(!isExportDropdownOpen)}
                icon={chev}
                iconPosition="right"
                size="small"
                variant="secondary"
              />
              {isExportDropdownOpen && (
                <div className="absolute right-0 top-full mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                  {exportOptions.map((option, index) => (
                    <button
                      key={index}
                      className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 text-sm"
                      onClick={option.onClick}
                    >
                      <span className="text-lg">{option.icon}</span>
                      <span>{option.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <InvoiceTable />
      </div>
    </div>
  );
}
